<nav class="nav-tabla">
    <ul>
      <li routerLinkActive="activo" *ngIf="!basica">
        <a [routerLink]="['/cliente/instalaciones']">Instalaciones</a>
      </li>
      <li routerLinkActive="activo">
        <a [routerLink]="['/cliente/contratistas']">Contratistas</a>
      </li>
      <li routerLinkActive="activo">
        <a [routerLink]="['/cliente/centros']">Centros</a>
      </li>      
      <li routerLinkActive="activo">
        <a [routerLink]="['/cliente/gestores']">Gestores</a>
      </li>
      <li routerLinkActive="activo">
        <a [routerLink]="['/cliente/transportista']">Transportistas</a>
      </li>
    </ul>
  </nav>
  
